import { useState } from 'react';
import { safeParseConfig } from '../blockConfig';
import VideoEmbedPreview from '../../../components/VideoEmbedPreview';

const DEFAULT = { url: '', description: '' };

// Separate from MediaBlockEditor.jsx (which owns the self-hosted-file
// image/audio/video types) on purpose - this is only ever a pasted external
// link (YouTube/Vimeo), never an upload, so no MediaUploader here. Live
// VideoEmbedPreview right in the editor so the author sees immediately
// whether the pasted link actually resolves before saving.
export default function VideoEmbedEditor({ block, onSave, onCancel }) {
   const initial = safeParseConfig(block.config, DEFAULT);
   const [url, setUrl] = useState(initial.url || '');
   const [description, setDescription] = useState(initial.description || '');

   const handleSave = () => onSave({ config: JSON.stringify({ url, description }) });

   return (
      <div className='exercise-block-media-editor'>
         <div className='exercise-block-field'>
            <label className='exercise-block-field-label'>Посилання на відео</label>
            <input className='exercise-block-generic-text' value={url}
               placeholder='https://www.youtube.com/watch?v=...'
               onChange={e => setUrl(e.target.value)} />
         </div>
         <div className='exercise-block-field'>
            <label className='exercise-block-field-label'>Опис</label>
            <input className='exercise-block-generic-text' value={description}
               placeholder='Необовʼязково' onChange={e => setDescription(e.target.value)} />
         </div>
         <VideoEmbedPreview url={url} description={description} />
         <div className='exercise-block-editor-actions'>
            <button type='button' className='exercise-block-save-btn' onClick={handleSave}>Зберегти</button>
            <button type='button' className='exercise-block-cancel-btn' onClick={onCancel}>Скасувати</button>
         </div>
      </div>
   );
}

export function renderVideoEmbedPreview(block) {
   const cfg = safeParseConfig(block.config, DEFAULT);
   return <VideoEmbedPreview url={cfg.url} description={cfg.description} />;
}
